/* Zareen Jewels — product card quick add.
   Uses Dawn's own cart notification (or drawer) so the "added to cart" popup and the
   cart bubble update exactly like the product page does. Delegated, so it works for
   cards rendered anywhere, including after section reloads in the theme editor. */
(() => {
  if (window.zjCardReady) return;
  window.zjCardReady = true;

  const setState = (btn, state, label) => {
    btn.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) btn.classList.add(state);
    const l = btn.querySelector('[data-zjp-label]');
    if (l) l.textContent = label || 'Add to bag';
    btn.disabled = state === 'is-loading';
  };

  /* ---------- colour swatches: switch the card to that variant ---------- */
  const pick = (sw, focus) => {
    const card = sw.closest('[data-zjp]');
    if (!card) return;
    const group = sw.closest('[data-zjp-swatches]');
    group.querySelectorAll('[data-zjp-swatch]').forEach((b) => {
      const on = b === sw;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    if (focus) sw.focus();
    const d = sw.dataset;
    const img = card.querySelector('.zjp__img--main');
    if (img && d.img && img.getAttribute('src') !== d.img) {
      img.classList.add('is-swapping');
      const done = () => img.classList.remove('is-swapping');
      img.addEventListener('load', done, { once: true });
      setTimeout(done, 1200);
      img.srcset = d.srcset || '';
      img.src = d.img;
    }
    card.classList.add('has-picked');
    const price = card.querySelector('[data-zjp-price]');
    if (price) { price.textContent = d.price; price.classList.toggle('is-sale', !!d.compare); }
    const was = card.querySelector('[data-zjp-was]');
    if (was) { was.textContent = d.compare || ''; was.hidden = !d.compare; }
    const sale = card.querySelector('[data-zjp-sale]');
    if (sale) { sale.hidden = !d.compare; const n = sale.querySelector('[data-zjp-off]'); if (n && d.off) n.textContent = `${d.off}%`; }
    card.querySelectorAll('[data-zjp-url]').forEach((a) => { a.href = d.url; });
    const available = d.available === 'true';
    card.classList.toggle('is-soldout', !available);
    const add = card.querySelector('[data-zjp-add]');
    if (add) {
      add.dataset.variantId = d.variantId;
      add.disabled = !available;
      add.setAttribute('aria-label', available ? `Add ${add.dataset.title} in ${d.name} to bag` : `${add.dataset.title} in ${d.name} is sold out`);
      const l = add.querySelector('[data-zjp-label]');
      if (l) l.textContent = available ? 'Add to bag' : 'Sold out';
    }
  };
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-zjp-swatch]');
    if (sw) { e.preventDefault(); pick(sw); }
  });
  document.addEventListener('keydown', (e) => {
    const sw = e.target.closest && e.target.closest('[data-zjp-swatch]');
    if (!sw || !['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    e.preventDefault();
    const all = [...sw.closest('[data-zjp-swatches]').querySelectorAll('[data-zjp-swatch]')];
    const dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
    pick(all[(all.indexOf(sw) + dir + all.length) % all.length], true);
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zjp-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const fd = new FormData();
    fd.append('id', btn.dataset.variantId);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }

    setState(btn, 'is-loading');
    try {
      const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd,
      });
      const data = await res.json();
      if (data.status) {
        setState(btn, 'is-error', data.description ? 'Unavailable' : 'Try again');
        setTimeout(() => setState(btn), 2400);
        return;
      }
      setState(btn, 'is-added', 'Added');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zj-product-card', productVariantId: btn.dataset.variantId, cartData: data });
      }
      document.dispatchEvent(new CustomEvent('zj:cart-added', { detail: data }));
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
      setTimeout(() => setState(btn), 2200);
    } catch (err) {
      setState(btn, 'is-error', 'Try again');
      setTimeout(() => setState(btn), 2400);
    }
  });
})();
